export const carouselExtensionType = 'com.atlassian.confluence.carousel';
export const carouselExtensionKey = 'carousel';
export const carouselContentAnalyticSource = 'carouselExtension';
export const carouselConfigAnalyticSource = 'carouselExtensionConfig';

export const AUTOPLAY_SECONDS = 8;
export const ARIA_CONTROLS_PREFIX = 'carousel-navigation-frame-';

export const CAROUSEL_VERSION_1 = '1';
export const CAROUSEL_VERSION_2 = '2';
export const FRAMES_LIMIT_V2 = 10;
